<template>
    <Modal :is-open="isOpen" @close="$emit('close')">
        <template #title>{{ $t('legal.terms.title') }}</template>

        <div class="prose prose-lg max-w-none">
            <p class="text-gray-600 mb-6">{{ $t('legal.terms.lastUpdated') }}</p>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.acceptance.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.acceptance.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.services.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.services.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.obligations.title') }}</h2>
                <p class="text-gray-700 mb-3">{{ $t('legal.terms.obligations.content') }}</p>
                <ul class="list-disc pl-6 space-y-2">
                    <li v-for="(item, index) in $tm('legal.terms.obligations.items')" :key="index" class="text-gray-700">
                        {{ item }}
                    </li>
                </ul>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.intellectualProperty.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.intellectualProperty.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.liability.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.liability.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.termination.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.termination.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.governingLaw.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.governingLaw.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.changes.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.changes.content') }}</p>
            </section>

            <section class="mb-6">
                <h2 class="text-xl font-semibold mb-3">{{ $t('legal.terms.contact.title') }}</h2>
                <p class="text-gray-700">{{ $t('legal.terms.contact.content') }}</p>
            </section>
        </div>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '../molecules/Modal.vue';

export default defineComponent({
    name: 'TermsOfServiceModal',
    components: {
        Modal
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    emits: ['close']
});
</script>
